export enum CompetenceCategory {
  PROFESSIONAL = "professional",
  METHODOLOGICAL = "methodological",
  SOCIAL = "social",
  SELF = "self",
}

export const competenceCategoryTranslations: Record<CompetenceCategory, string> = {
  [CompetenceCategory.PROFESSIONAL]: "Fachkompetenz",
  [CompetenceCategory.METHODOLOGICAL]: "Methodenkompetenz",
  [CompetenceCategory.SOCIAL]: "Sozialkompetenz",
  [CompetenceCategory.SELF]: "Selbstkompetenz",
};

export function getCompetenceCategoryOptions() {
  return Object.values(CompetenceCategory).map((value) => ({
    value,
    label: competenceCategoryTranslations[value],
  }));
}
